// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "content_generation_provenance".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "content_generation_provenance" table (1:1 with a DB row, on the wire). */
export const contentGenerationProvenanceAtomSchema = z.object({
    id: z.string(),
    subjectType: z.enum(['graphic', 'video']),
    subjectId: z.string(),
    batchId: z.string().nullable(),
    batchItemId: z.string().nullable(),
    serviceId: z.string().nullable(),
    chosenAssetId: z.string().nullable(),
    mediaSource: z.enum(['service-video-thumbnail', 'service-image-asset', 'owner-selected', 'stock', 'ai-generated', 'none']),
    logoOutcome: z.enum(['used', 'missing-no-logo', 'missing-fetch-failed', 'not-applicable']),
    candidatesConsidered: z.array(z.string()).nullable(),
    rejectedCandidates: z.unknown().nullable(),
    templateSlug: z.string().nullable(),
    model: z.string().nullable(),
    detail: z.unknown().nullable(),
    organizationId: z.string(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=contentGenerationProvenance.js.map